import React from "react";

const IconIntegratedForms = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" fill="none" className={className}>
    <path
      d="M10 20.2C13.59 20.2 16.5 17.29 16.5 13.7C16.5 10.11 13.59 7.19995 10 7.19995C6.41 7.19995 3.5 10.11 3.5 13.7C3.5 17.29 6.41 20.2 10 20.2Z"
      fill="url(#paint0_linear_146_241)"
    />
    <path
      d="M14.25 3.12C15.24 3.12 15.73 3.12 16.14 3.23C17.24 3.53 18.1 4.38 18.39 5.48C18.5 5.88 18.5 6.38 18.5 7.37V17.14C18.5 18.93 18.5 19.82 18.15 20.5C17.84 21.1 17.36 21.59 16.76 21.89C16.08 22.24 15.19 22.24 13.4 22.24H6.59999C4.81999 22.24 3.91999 22.24 3.23999 21.89C2.63999 21.58 2.14999 21.1 1.84999 20.5C1.49999 19.82 1.5 18.93 1.5 17.14V7.37C1.5 6.38 1.5 5.89 1.61 5.48C1.91 4.38 2.76 3.52 3.86 3.23C4.26 3.12 4.76 3.12 5.75 3.12M6.81999 13.75L8.94 15.87L13.72 11.09M7.45 5.25H12.55C13.14 5.25 13.44 5.25 13.67 5.13C13.87 5.03 14.03 4.87 14.13 4.67C14.25 4.44 14.25 4.15 14.25 3.55V2.7C14.25 2.1 14.25 1.81 14.13 1.58C14.03 1.38 13.87 1.22 13.67 1.12C13.44 0.999995 13.15 1 12.55 1H7.45C6.86 1 6.56 0.999995 6.33 1.12C6.13 1.22 5.97 1.38 5.87 1.58C5.75 1.81 5.75 2.1 5.75 2.7V3.55C5.75 4.15 5.75 4.44 5.87 4.67C5.97 4.87 6.13 5.03 6.33 5.13C6.56 5.25 6.85 5.25 7.45 5.25Z"
      stroke="#191E49"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="paint0_linear_146_241" x1="10" y1="7.19995" x2="10" y2="20.2" gradientUnits="userSpaceOnUse">
        <stop stopColor="#C098F5" />
        <stop offset="1" stopColor="#C098F5" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default IconIntegratedForms;
